import { EXERCISES_ACTION, EXERCISES_DOMAIN, EXERCISES_ENDPOINT, EXERCISES_PATH } from '../../constants'
import getByIdExerciseSelector from '../../selectors/get-by-id'
import getPathFromDomainPathReduxUtil from '../../../../redux/utils/get-path-from-domain-path'
import { logUtil } from 'packages/src'
import { EXERCISE_CLASS_NAME } from '../../../model'
import REDUX_OPTION from '../../../../redux/constants/option'
import { loadInstanceReduxAction } from '../../../../redux/actions/load-instance'
import { MODEL_KEY } from '../../../../../modules/model/constants'

function loadByIdExerciseAction (id) {
  return async (dispatch, getState) => {
    try {
      if (getByIdExerciseSelector(id)(getState())) {
        logUtil('').debug('already exists')
        return
      }

      const options = {
        [REDUX_OPTION.NO_AUTH_NEEDED]: true
      }

      return dispatch(loadInstanceReduxAction({
        type: EXERCISES_ACTION.LOAD_BY_ID,
        payload: {
          endpoint: `${EXERCISES_ENDPOINT.EXERCISES}/${id}`,
          domainListPath: EXERCISES_PATH.ALL,
          path: getPathFromDomainPathReduxUtil(EXERCISES_DOMAIN, id),
          data: {
            [MODEL_KEY.CLASS_NAME]: EXERCISE_CLASS_NAME,
            id
          },
          options
        }
      }))
    } catch (error) {
      logUtil('').warn(`loading exercise by id ${id} failed `, error)
    }
  }
}

export { loadByIdExerciseAction }
